import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent { }



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/containers/full-layout/full-layout.component.ts